// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zez0","left":"styles_left__2ePNb"};